import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { FolderType, WorkspaceRole, WorkspaceState } from './types';
import { migrateLegacyAppStorage } from './migrateLegacyStorage';

migrateLegacyAppStorage();

type WorkspaceActions = {
  setWorkspace: (payload: WorkspaceState) => void;
  resetWorkspace: () => void;
};

const defaultWorkspace: WorkspaceState = {
  currentFolderId: null,
  folderType: null,
  role: 'owner',
};

export const useWorkspaceStore = create<WorkspaceState & WorkspaceActions>()(
  persist(
    (set) => ({
      ...defaultWorkspace,

      setWorkspace: (payload) => set(payload),

      resetWorkspace: () => set(defaultWorkspace),
    }),
    {
      name: 'app-workspace',
      partialize: (state) => ({
        currentFolderId: state.currentFolderId,
        folderType: state.folderType,
        role: state.role,
      }),
    }
  )
);

export type { FolderType, WorkspaceRole };
